import type { QBusEventMap } from "@otto-ec/global-resources";

export enum FTNAV_EVENT {
  OPENED = "ftnav.global-navigation.opened",
  CLOSE = "ftnav.global-navigation.close",
  REGISTER_SLIDER = "ftnav.slider.register",
  REGISTERED_SLIDER = "ftnav.slider.registered"
}

export type FTNavEvents = QBusEventMap<{
  [FTNAV_EVENT.OPENED]: [];
  [FTNAV_EVENT.CLOSE]: [];
  [FTNAV_EVENT.REGISTERED_SLIDER]: ["squirrel_nav_slider_wrapper"];
  [FTNAV_EVENT.REGISTER_SLIDER]: ["squirrel_nav_slider_wrapper"];
}>;

export class FTNavEvent {
  static close() {
    window.o_global.events<FTNavEvents>().emit(FTNAV_EVENT.CLOSE);
  }
}
